import React, { useEffect, useState } from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import appApi from "../../assets/utils/AppApi";
import Hint from "../../assets/components/Hint";
import Classes from "./styles/style.module.css";
import Keys from "./keys";
import UsersRequests from "../../assets/services/user";
import { useDispatch } from "react-redux";
import Loading from "../../assets/containers/loadingDialog";
import { Wheel } from "react-custom-roulette";
import CustomButton from "../../assets/components/CustomButton";
import errorHandler from "../../assets/utils/ErrorHandler";
import WinModal from "../../assets/thridParty/WinModal";

const segColors = ["#EE4040", "#F0CF50", "#815CD1", "#3DA5E0", "#34A24F"];

const FortuneWhile = () => {
  const [loading, setLoading] = useState(false);
  const [segments, setSegments] = useState([]);
  const [mustSpin, setMustSpin] = useState(false);
  const [winngSegment, setWinngSegment] = useState(0);
  const [showWinModal, setShowWinModal] = useState(false);
  const [prize, setPrize] = useState(null);

  const dispatch = useDispatch();

  const getAllPrizes = async () => {
    setLoading(true);
    try {
      await appApi.get(`/fortuneWheelPrize/getall`).then(({ data }) => {
        const prizes = data.data;
        let allVariables = [];
        prizes.forEach((element) => {
          allVariables.push({ option: element.name });
        });
        setSegments(allVariables);
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllPrizes();
  }, []);

  const onFinished = () => {
    dispatch(UsersRequests.getme());
  };

  const buyPrize = async (useCoin) => {
    if (!mustSpin) {
      try {
        await appApi
          .get(`/fortuneWheel/buy?useCoin=${useCoin}`)
          .then(({ data }) => {
            if (data.prize) {
              setPrize(data.prize);
              segments.forEach((seg, index) => {
                if (seg.option === data.prize.name) {
                  setWinngSegment(index);
                }
              });
              setMustSpin(true);
            }
          });
      } catch (error) {
        errorHandler(error);
        setMustSpin(false);
      }
    }
  };

  return (
    <AnimatedPageContainer>
      <div className="w-100 text-center">
        <div className={Classes.hintContainer}>
          <Hint
            hintText={"هر هفته یک بار فرصت شرکت در گردونه شانس وجود دارد."}
          />
        </div>
        <Keys />
        <div className={Classes.fortuneWheelContainer}>
          {!loading ? (
            segments.length === 0 ? (
              <p className="text-center">موردی برای نمایش وجود ندارد</p>
            ) : (
              <div className={Classes.wheelContainer}>
                <Wheel
                  mustStartSpinning={mustSpin}
                  prizeNumber={winngSegment}
                  data={segments}
                  backgroundColors={segColors}
                  textColors={["#ffffff"]}
                  onStopSpinning={() => {
                    setMustSpin(false);
                    setShowWinModal(true);
                  }}
                  fontFamily="IRANSansXFaNum"
                  disableInitialAnimation={true}
                />
                <div>
                  <CustomButton
                    text={mustSpin ? "صبر کنید" : " چرخش رایگان"}
                    color={"primary"}
                    shadow={true}
                    styles={{
                      width: "50%",
                      marginBlock: "16px",
                      marginInline: "auto",
                      display: "block",
                    }}
                    clickHandler={() => buyPrize(false)}
                  />
                  <CustomButton
                    text={mustSpin ? "صبر کنید" : " چرخش به ازای دو کلید"}
                    color={"secondary"}
                    shadow={true}
                    styles={{
                      width: "50%",
                      marginTop: "16px",
                      marginInline: "auto",
                      display: "block",
                      marginBottom: "20px",
                    }}
                    clickHandler={() => buyPrize(true)}
                  />
                </div>
              </div>
            )
          ) : (
            <div className="my-5 py-5 w-100 d-flex justify-content-center">
              <Loading size={30} />
            </div>
          )}
        </div>
      </div>
      <WinModal
        show={showWinModal && prize}
        handleClose={() => {
          setShowWinModal(false);
          setPrize(null);
          onFinished();
        }}
        prize={prize?.name}
        desc={prize?.description}
        type={prize?.type}
      />
    </AnimatedPageContainer>
  );
};

export default FortuneWhile;
